import { Package, Activity, ClipboardCheck } from 'lucide-react'
import ProcessItems from './ProcessItems'
import ProcessLogs from './ProcessLogs'
import ProcessApprovalProgress from './ProcessApprovalProgress'

export const tabs = (process: any) => [
    {
        label: 'Items',
        value: 'items',
        startIcon: <Package className="text-primary w-4 h-4" />,
        component: <ProcessItems />,
    },
    {
        label: 'Approval Progress',
        value: 'approval',
        startIcon: <ClipboardCheck className="text-primary w-4 h-4" />,
        component: <ProcessApprovalProgress process={process} />,
    },
    {
        label: 'Activity Logs',
        value: 'logs',
        startIcon: <Activity className="text-primary w-4 h-4" />,
        component: <ProcessLogs />,
    },
]
